// extracted by mini-css-extract-plugin
export default {"blackButton":"blackButton_blackButton__9Ya-y"};